import { styled, css, keyframes } from '@mui/material'
import Logo from '../Logo'
import ModalBox from '../ModalBox'
import Text from '../Text'

export const LoaderWrapper = styled(ModalBox, {
  shouldForwardProp: (prop) => !['fullScreen'].includes(String(prop))
})(
  ({ fullScreen }) => css`
    .ModalBoxWrapper {
      justify-content: center;
      align-items: center;
      min-height: 220px;
      max-width: ${fullScreen ? '100%' : '220px'};
      padding: 32px;
      gap: 32px;
    }
  `
)

const rotation = keyframes`
  to {
    transform: rotate(360deg);
  }
`

export const LoaderIcon = styled('div')(
  ({ theme }) => css`
    width: 48px;
    height: 48px;
    border: 4px solid ${theme.palette.primary.main};
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: ${rotation} 0.8s linear infinite;
  `
)

export const LoaderLogo = styled(Logo)(() => css``)
LoaderLogo.defaultProps = {
  size: 64
}

export const LoaderLabel = styled(Text)(() => css``)
LoaderLabel.defaultProps = {
  size: 16
}
